import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { WorkspaceTaskGroupRow } from "../workspaceTaskGroupsViewConfig";

export const TaskGroupCountCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        WorkspaceTaskGroupRow,
        number | null
    >) => <span>{row.original.taskCount ?? "-"}</span>,
);
